
import { Description, FormHeading, FormWrapper, ImgSVG, ViewBody } from "./styles"
import warehouse from "../../../assets/icons/warehouse.svg";


export type RouteName =
    | 'MailHasBeenSent'
    | 'X'
    | 'Y';


export type ThankYouPageDeclaration = {
    title: string;
    description: string
};

export const messageContent: Record<RouteName, ThankYouPageDeclaration> = {
    MailHasBeenSent: {
        title: 'Sprawdź skrzynkę odbiorczą',
        description: 'Jeśli podany adres e-mail istnieje w bazie, otrzymasz link do strony pozwalającej ustawić nowe hasło.',
    },
    X: {
        title: 'New title X!',
        description: 'New description X',
    },
    Y: {
        title: 'New title Y!',
        description: 'New description Y',
    },

};



// export const ThankYouPage = (props: ThankYouPageDeclaration) => {
//     //let navigate = useNavigate();
//     return (

//         <ViewBody>
//             <ImgSVG src={warehouse} />
//             <FormWrapper>
//                 <FormHeading>{props.title}</FormHeading>
//                 <Description>{props.description}</Description>
//             </FormWrapper>
//         </ViewBody >

//     );
// };


export const ThankYouPage = () => {
    return (

        <ViewBody>
            <ImgSVG src={warehouse} />
            <FormWrapper>
                <FormHeading>Sprawdź skrzynkę odbiorczą</FormHeading>
                <Description>Jeśli podany adres e-mail istnieje w bazie, otrzymasz link do strony pozwalającej ustawić nowe hasło.</Description>
            </FormWrapper>
        </ViewBody >

    );
};